import {useState} from 'react';
import {Row, Col, Button, Form, Accordion} from 'react-bootstrap';
import {usePortalContext} from '../../lib/context/portalContext';
import {useCustomerContext} from '../../lib/context/customerContext';
import {useUserMutations} from './userMutations';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSearch} from '@fortawesome/pro-light-svg-icons';
import cx from 'classnames';
import withAlerts from '../../lib/withAlerts';
import {compose} from '../../lib/compose';

export const MdmDetail = ({watch = () => {}, errors = {}, handleSubmit = () => {}, setValue = () => {}, register = () => {}, hasphone, phonefield = '', alerts: {success, error}}) => {
  const {rowData} = usePortalContext();
  const {mdm_device_id} = rowData?.user || {mdm_device_id: ''};
  const {searchMdmId} = useUserMutations();
  const {hasPermission} = useCustomerContext();
  const [showError, setShowError] = useState(false);
  const [manual, setManual] = useState(false);
  const mdmEditDisabled = !hasPermission('USER_MDM_LINK_EDIT');
  
  const handleMdmAssignment = async () => {
    
    if(!phonefield || phonefield == '') {
      return hasphone();
    }

    if(phonefield?.length) {
      const searchMdm = await searchMdmId({variables: {mdm_input: {phone: phonefield}}})

      if(searchMdm?.errors) {
        await hasphone();

        setShowError(true);
        error({msg: 'There was an error finding the associated MDM Device ID. Please try again.'});
      } else {
        const parsed = JSON.parse(searchMdm?.data?.SearchMdmId);
        setValue('mdm_device_id', parsed?.result?.mdm_device_id, {
          shouldDirty: true,
          shouldTouch: true,
          shouldValidate: true
        });
        success({msg: 'MDM Device ID found.'})
      }
    }
  }

  const removeMdmIntegration = async () => {
    setValue('mdm_device_id', '', { shouldDirty: true });
    handleSubmit();
  }

  // searching for MDM device id:  (16026210007, +16026210007, 6026210007)
  // all of these should give: 8ad7f6be-4d98-4deb-9d4d-13945eae0251
 

  return (
    <Row>
      <Col>
        <Form.Group className="mb-5">
          <Accordion flush id="user-mdm-accordion">
            <Accordion.Item eventKey="0">
              <Accordion.Header as="div">
                <Form.Label>MDM Integration {mdm_device_id && '- Activated'}</Form.Label>
              </Accordion.Header>
              <Accordion.Body>
                {!mdm_device_id && !mdmEditDisabled && <p>Enter phone number above to search for MDM Device ID <b>OR</b> enter MDM Device ID manually below.</p>}
                {showError && <p>MDM Device ID cannot be found. Please make sure phone number is correct and search again, or enter MDM Device ID directly.</p> }
                {!mdm_device_id && !manual && !mdmEditDisabled && <p className="link-span privoro-blue" onClick={handleMdmAssignment}> {showError && "Retry -"} Search for MDM Device ID by phone <FontAwesomeIcon icon={faSearch} size="sm"/></p>}
                <Form.Control
                  {...register('mdm_device_id', {
                    onChange: (e) => {
                      setShowError(false)
                      if(e.target.value) {
                        setManual(true)
                      } else {
                        setManual(false)
                      }
                    },
                    validate: (value) => {
                      if (!value) {
                        return;
                      } else {
                        const regex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
                        return regex.test(value) || "Invalid MDM Device ID format";
                      }
                    }                    
                  })}
                  type="text"
                  defaultValue={mdm_device_id}
                  disabled={mdmEditDisabled}
                  placeholder="MDM Device ID (optional)"
                  className={cx('mb-3', {'error-input': errors?.mdm_device_id})}
                />
                
                {/* RBAC: USER_MDM_LINK_EDIT - explicitly "hide the 'Remove MDM
                    Device Integration' link" */}
                {mdm_device_id?.length !== 0 && !mdmEditDisabled && <p className="link-span" onClick={removeMdmIntegration}>Remove MDM Device Integration</p>}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Form.Group>
      </Col>
    </Row>
  )
}

export default compose(
  withAlerts
)(MdmDetail);
